import {DataService} from "@mojility/coach-core";

export default {
  name: 'dataService',
  fn: DataService
};
